<template>
    <BasicModalWindow
      ref="modal"
      class="emojis-modal small-window"
      title="editor.emojis_title"
    >
        <template #pre-body>
            <div class="tabs">
                <span v-for="image,index in emoji_tabs" :key="'em_i_' + index"
                    :class="{active : active_tab === index}"
                    @click="onChangeTab(index)"
                    role="button"
                    class="button"
                    tabindex="0"
                >
                    <img
                      :src="config.path + image + config.extension" :width="config.width" :height="config.height" />
                </span>
            </div>
        </template>


        <template #body>
            <div class="emojis">
                <span v-for="image,tab in emoji_images[active_tab]" :key="tab" @click="onAddEmoji(image)">
                  <img :src="config.path + image + config.extension" :width="config.width" :height="config.height" />
                </span>
            </div>
        </template>

        <template #footer>
            <ActionButton
              @click="close()"
              text="global.actions.close"
            />
        </template>
    </BasicModalWindow>
</template>

<script setup>
  import { ref, defineProps, onBeforeMount } from 'vue';
  import BasicModalWindow                    from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                        from '@/vue/Elements/Buttons/ActionButton.vue'
  import Language                            from '@/js/Shared/Language/Language.js';
  import SAPOMailConfig                      from '@/SAPOMailConfig';

  const props = defineProps({
    html_editor : {},
  })

  const config     = SAPOMailConfig.client.emojis;
  const modal      = ref();
  const active_tab = ref('smileys');
  const emoji_tabs = {
    'smileys'    : 'EMOTICON_DEFAULT',
    'characters' : 'EMOTICON_BATMAN',
    'objects'    : 'SHOW_ONLINE',
  };

  const emoji_images = {
    'smileys'    : [
      'EMOTICON_DEFAULT',
      'EMOTICON_SMILE',
      'EMOTICON_HAPPY',
      'EMOTICON_BLINK',
      'EMOTICON_CONFUSED',
      'EMOTICON_AMAZED',
      'EMOTICON_SIDEMOUTH',
      'EMOTICON_SERIOUS',
      'EMOTICON_SNOB',
      'EMOTICON_TONGUE',
      'EMOTICON_SECRET',
      'EMOTICON_CRY',
      'EMOTICON_SARCASTIC',
      'EMOTICON_NOSTALGIC',
      'EMOTICON_MAD',
      'EMOTICON_KISS',
      'EMOTICON_INLOVE',
      'EMOTICON_SAD',
      'EMOTICON_SLEEPING',
      'EMOTICON_EMPLASTRO',
      'EMOTICON_COCO',
      'EMOTICON_ANNOYED',
      'EMOTICON_BARF',
      'EMOTICON_ANGRY',
      'EMOTICON_RUDE',
      'EMOTICON_ANGEL',
      'EMOTICON_BUNNY',
      'EMOTICON_CYCLOPS',
      'EMOTICON_TIRED',
      'EMOTICON_BRRRPT',
      'EMOTICON_BLUSHED',
      'EMOTICON_DROOL',
      'EMOTICON_DORK',
      'EMOTICON_ILL',
    ],
    'characters' : [
      'EMOTICON_BENFICA',
      'EMOTICON_PORTO',
      'EMOTICON_SPORTING',
      'EMOTICON_PORTUGAL',
      'EMOTICON_UNSHAVED',
      'EMOTICON_WASTED',
      'EMOTICON_CHUCHA',
      'EMOTICON_BARBUDO',
      'EMOTICON_MASCARA',
      'EMOTICON_STYLE',
      'LOCAL_FARO',
      'EMOTICON_SKULL',
      'EMOTICON_PAINATAL',
      'EMOTICON_CARNAVAL',
      'EMOTICON_CLOWN',
      'EMOTICON_NINJA',
      'EMOTICON_BATMAN',
      'EMOTICON_KING',
      'EMOTICON_MARINHA',
      'EMOTICON_INVISIBLE',
      'EMOTICON_EVIL',
    ],
    'objects'    : [
      'EMOTICON_LIPS',
      'EMOTICON_NO',
      'EMOTICON_OK',
      'EMOTICON_RAINBOW',
      'EMOTICON_STAR',
      'EMOTICON_SOL',
      'EMOTICON_LUA',
      'EMOTICON_XMASTREE',
      'SHOW_UNKNOWN',
      'EMOTICON_ORANGEFLOWER',
      'EMOTICON_BLUEFLOWER',
      'EMOTICON_REDFLOWER',
      'EMOTICON_BOUQUETE',
      'EMOTICON_SADFLOWER',
      'EMOTICON_DYINGFLOWER',
      'EMOTICON_HIDE',
      'EMOTICON_ICE',
      'EMOTICON_UNHEART',
      'EMOTICON_FOOD',
      'SHOW_BRASAS',
      'SHOW_AWAY',
      'SHOW_BLOCKED',
      'SHOW_CHAT',
      'SHOW_DND',
      'SHOW_LOCKED',
      'SHOW_MEETING',
      'EMOTICON_FALLINGSTAR',
      'SHOW_OFFLINE',
      'SHOW_ONLINE',
      'SHOW_XA',
      'EMOTICON_GIFT',
      'EMOTICON_BEER',
      'EMOTICON_COFFEE',
      'EMOTICON_PHONE',
      'EMOTICON_BOOT',
      'EMOTICON_FLORVIOLETA',
      'EMOTICON_FLORBRANCA',
    ],
  }

  const onAddEmoji = (emoji) => {
    addEmojiToEditor(emoji);
  }

  const onChangeTab = (tab) => {
    setActiveTab(tab);
  }

  const addEmojiToEditor = (emoji) => {
    let img = document.createElement('img');
    img.setAttribute('alt'   , emoji);
    img.setAttribute('src'   , config.path + emoji + config.extension);
    img.setAttribute('width' , config.width);
    img.setAttribute('height', config.height);
    props.html_editor.insertHTML(img);
  }

  const setActiveTab = (active) => {
    active_tab.value = active;
  }

  const close = () => {
    modal.value.close();
  }
</script>
